<div class="text-center">
    <img src='/assets/3.png' class="onboarding-img" alt='image'>
    <div class="text-center ml-auto mr-auto w-50">
        <h1>Designed For You</h1>
        <p>
            The Tranqsleep Program is an web-based therapy done in cooperation with your sleep specialist. 
        </p>
    </div>
    </div>